import * as React from "react";

import { JSX } from "react/jsx-runtime";

const UniversityIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={27}
    height={26}
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="university">
      <path
        id="Vector"
        d="M2.66675 23.8333H23.7917"
        stroke="black"
        strokeWidth={1.625}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M3.75 14.0833V23.8333M23.25 14.0833V23.8333"
        stroke="black"
        strokeWidth={1.625}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M8.625 8.66669V23.8334M18.375 8.66669V23.8334"
        stroke="black"
        strokeWidth={1.625}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_4"
        d="M2.66675 14.0833H8.08341M24.3334 14.0833H18.9167"
        stroke="black"
        strokeWidth={1.625}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_5"
        d="M7.54175 8.66669H19.4584"
        stroke="black"
        strokeWidth={1.625}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_6"
        d="M13.5 8.66669V5.39742M13.5 5.39742V3.2179C13.5 2.70419 13.5 2.44733 13.6586 2.28773C14.1566 1.78686 16.2083 2.97164 16.9887 3.4521C17.6475 3.85783 17.8333 4.66826 17.8333 5.39742H13.5Z"
        stroke="black"
        strokeWidth={1.625}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_7"
        d="M13.5 23.8334V21.6667"
        stroke="black"
        strokeWidth={1.625}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_8"
        d="M11.875 13V13.5417M15.125 13V13.5417"
        stroke="black"
        strokeWidth={1.625}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_9"
        d="M11.875 17.3333V17.875M15.125 17.3333V17.875"
        stroke="black"
        strokeWidth={1.625}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default UniversityIcon;
